var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-number"},[_c('i',{class:[
      'e6-icon-minus_fill',
      'input-number-icon',
      _vm.minDisabled ? 'input-number-icon--disabled' : ''
    ],on:{"click":_vm.handleSubtract}}),_vm._v(" "),_c('el-input-number',{ref:"input",staticClass:"input-number-input",attrs:{"controls":false,"min":_vm.min,"max":_vm.max,"step":_vm.step,"precision":0},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}}),_vm._v(" "),_c('i',{class:[
      'e6-icon-add_fill',
      'input-number-icon',
      _vm.maxDisabled ? 'input-number-icon--disabled' : ''
    ],on:{"click":_vm.handleAdd}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }